<template>
  <div
    class="printing-row-root"
    :style="styles"
  >
    <div class="printing-row-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    gutterBottom: {
      type: Number,
      default: 5,
    },
    gutterTop: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    styles() {
      return `
        padding-bottom: ${this.gutterBottom}px;
        padding-top: ${this.gutterTop}px;
      `;
    },
  },
};
</script>

<style lang="scss" scoped>
.printing-row-content {
  display: flex;
  flex-wrap: wrap;
}
.printing-row-title {
  margin-bottom: 5px;
}
</style>
